export enum NationBuilderAccessTokenStatus {
  Valid = "valid",
  Invalid = "invalid",
  Loading = "loading",
}
